import React from "react";
import userLogo from "../../../Assets/user.svg";
import Icon from "../Atoms/Icon";
import styles from "../../Styles/UserInfo.module.css";

const UserInfo = ({ userName }) => {
  return (
    <div className={styles.user_info}>
      <p>{userName}</p>
      <Icon name={"user"} image={userLogo}>
        user
      </Icon>
    </div>
  );
};

export default UserInfo;
